import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, ViewChild, HostBinding } from "@angular/core";
import { MatCheckboxChange, MatSlider } from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common"
import { Observable, Subscription } from "rxjs";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { CoreLanguageService } from "../../services/language.service";
import { CoreLogService } from "../../services/log.service";
import { UserHelperService } from "../../services/userHelper.service";
import { WebShopService } from "../../services/webShop.service";
import { WebShopMode } from "../../services/IWebShopService";
import { AddPurchaseOrderMemberDataModel, OrdertypeLocationSettings } from "../../shared/models";
import Utils from "../../shared/utils";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { TermService } from "../term/term.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { LocationImpressumDialogComponent } from "../../modalDialogs";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { snackBarMessageKey, SnackBarService } from "../../services/snackBar.service";
import { RemoteOrderGroupPaymentService } from "./remoteOrderGroupPayment.service";
import { IGroupManageData, ILocationData, Status } from "../../services/IRemoteGroupOrderService";
import { IDeliveryFeeInfo, IImpressumData, IMemberOrder } from "./remoteOrderGroupPayment.facade";
import { trigger, transition, animate, keyframes, style } from "@angular/animations";
import { CheckoutComponent } from "../checkout/checkout.component";
import { CustomerDataComponent } from "../customerData/customerData.component";
import { take } from "rxjs/operators";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";
import { SnackBarMessageType } from "../../shared/contentTypes";

const ORDER_NAVIGATION = "phPayment_Tab_Order_Overview";
const CUSTOMER_DATA_NAVIGATION = "phPayment_Tab_Order_Data";
const CHECKOUT_NAVIGATION = "phPayment_Tab_Order_Pay";

@Component({
  selector: "remoteOrderGroupPayment",
  templateUrl: "./remoteOrderGroupPayment.component.html",
  styleUrls: ["./remoteOrderGroupPayment.component.scss"],
  providers: [OverlaySpinnerService, RemoteOrderGroupPaymentService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("shake", [
      transition("true <=> false", animate("1000ms ease-in",
        keyframes([
          style({ transform: "translate3d(-1px, 0, 0)", offset: 0.1 }),
          style({ transform: "translate3d(2px, 0, 0)", offset: 0.2 }),
          style({ transform: "translate3d(-4px, 0, 0)", offset: 0.3 }),
          style({ transform: "translate3d(4px, 0, 0)", offset: 0.4 }),
          style({ transform: "translate3d(-4px, 0, 0)", offset: 0.5 }),
          style({ transform: "translate3d(4px, 0, 0)", offset: 0.6 }),
          style({ transform: "translate3d(-4px, 0, 0)", offset: 0.7 }),
          style({ transform: "translate3d(2px, 0, 0)", offset: 0.8 }),
          style({ transform: "translate3d(-1px, 0, 0)", offset: 0.9 }),
        ]))
      ),
    ]),
  ]
})
export class RemoteOrderGroupPaymentComponent implements OnInit, OnDestroy {

  @ViewChild("tipSlider", { read: MatSlider }) tipSlider: MatSlider;
  @HostBinding("class") class = "ya-typography mat-tab-group";
  @ViewChild(CheckoutComponent) checkout: CheckoutComponent;
  @ViewChild(CustomerDataComponent) customerData: CustomerDataComponent;

  private langSubscriber: Subscription;
  // User data (creator)
  public isRegistered: boolean = false;
  // Order data
  public serviceId: number;
  public WebShopMode = WebShopMode;
  /// Group data
  public groupManageData: IGroupManageData;
  public orders$: Observable<ReadonlyArray<IMemberOrder>>;
  public locationData$: Observable<ILocationData>;
  public tipSliderValue: number;
  public tipInputValue: string;
  public sum$: Observable<number>;
  public total$: Observable<number>;
  public canContinue$: Observable<boolean>
  public hasScheduledItems$: Observable<boolean>;//TODO
  public hasAGBaccepted$: Observable<boolean>;
  public AGB_innerhtml: any = "";

  public get hasAcceptedAGB(): boolean {
    return this._remoteOrderGroupPaymentService.hasAcceptedAGB;
  }
  public set hasAcceptedAGB(accepted: boolean) {
    this._remoteOrderGroupPaymentService.hasAcceptedAGB = accepted;
    this.PushChanges();
  }
  //Location
  public locationImpressumData: IImpressumData;
  public digipagerData: OrdertypeLocationSettings;
  // web shop settings
  public showTippingSlider: boolean;
  public canTip$: Observable<boolean>;
  public deliveryFeeInfo$: Observable<IDeliveryFeeInfo>;
  public getCustomerData: boolean = false;
  public get currencySymbol() {
    return this._webShopService.currencySymbol ? this._webShopService.currencySymbol : "€";;
  }
  //View settings
  public paymentNavigations: string[];
  public activeLink: string;
  public states = {};
  public displayListDetails: boolean = false;
  public isSmallView: boolean = false;
  public matGroupSelectedIndex: number = 0;

  constructor(
    private _remoteOrderGroupPaymentService: RemoteOrderGroupPaymentService
    , private _remoteGroupOrderService: RemoteGroupOrderService
    , private _webShopService: WebShopService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _userHelperService: UserHelperService
    , private _coreLanguageService: CoreLanguageService
    , private _iosHelperService: IOSHelperService
    , private _domSanitizer: DomSanitizer
    , private _termService: TermService
    , private _activatedRoute: ActivatedRoute
    , private _location: Location
    , _mainnavService: MainnavService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _snackBarService: SnackBarService
    ,
  ) {
    const me = this;
    me.tipSliderValue = 0;
    me.tipInputValue = me._webShopService.formatCurrency(0, false);

    me.isSmallView = _mainnavService.viewType === ViewType.Small;
    me.paymentNavigations = [ORDER_NAVIGATION];
    me.activeLink = ORDER_NAVIGATION;
    me.setTermAcceptance();
  }

  ngOnInit() {
    const me = this;
    me.serviceId = me._webShopService.getServiceMode();
    me.isRegistered = me._userHelperService.IsRegistered;
    me.groupManageData = me._remoteOrderGroupPaymentService.groupManageData;
    me.locationData$ = me._remoteOrderGroupPaymentService.locationData$;
    me.orders$ = me._remoteOrderGroupPaymentService.orders$;
    me.canTip$ = me._remoteOrderGroupPaymentService.canTip$;
    //Delivery fee
    if (me.serviceId === me.WebShopMode.DeliveryGroup) {
      me.deliveryFeeInfo$ = me._remoteOrderGroupPaymentService.deliveryFeeInfo$;
    }

    me._remoteOrderGroupPaymentService.tippingPercent$.subscribe((newTipPrecent) => {
      me.tipSliderValue = newTipPrecent;
    });

    me._remoteOrderGroupPaymentService.tippingAmount$.subscribe((newTipAmount) => {
      me.tipInputValue = this._webShopService.formatCurrency(newTipAmount, false);
    });

    me.sum$ = me._remoteOrderGroupPaymentService.sum$;
    me.total$ = me._remoteOrderGroupPaymentService.total$;
    me.canContinue$ = me._remoteOrderGroupPaymentService.canContinue$;

    //todo hasScheduledItems
    me.hasScheduledItems$ = me._remoteOrderGroupPaymentService.hasScheduledItems$;
    me.locationImpressumData = me._remoteOrderGroupPaymentService.locationImpressumData;
    me.RenderCheckout();
    me.PushChanges();
  }

  public get isGroupDelivery() {
    const me = this;
    return me.serviceId === me.WebShopMode.DeliveryGroup;
  }

  ngOnDestroy(): void {
    const me = this;
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("BasketComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public onShowTermsClick(event: any) {
    const target: HTMLElement = event.target;
    if (target.id) {
      const eleIdArray: string[] = target.id.split("-");
      if (eleIdArray.length === 2) {
        const termid: number = +(eleIdArray[eleIdArray.length - 1]);
        if (termid != null) {
          this.openTermModel(termid);
        }
      }
    }
    event.stopPropagation();
  }

  /** Open term model */
  public openTermModel(termId: number): void {
    const me = this;
    me._termService.openTermModel(termId);
  }

  /**Set AGB */
  private setTermAcceptance(): void {
    const me = this;
    // Get Data From Resolver Data
    const resolverData = me._activatedRoute.snapshot.data["settingsViewModel"];
    if (resolverData) {
      const settingsViewModel = resolverData["settingsViewModel"];
      me.AGB_innerhtml = settingsViewModel.register_term_text;
      me.AGB_innerhtml = me._domSanitizer.bypassSecurityTrustHtml(me.AGB_innerhtml);
    }
  }

  /**AGB event */
  public onAcceptAGBChange(event: MatCheckboxChange) {
    this.hasAcceptedAGB = event.checked;
    this.PushChanges();
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  public openLocationImpressumDialog() {
    const me = this;
    me._bottomSheetHelperService.open(
      LocationImpressumDialogComponent,
      {
        data: {
          impressumHtml: me._domSanitizer.bypassSecurityTrustHtml(me.locationImpressumData.impressumHtml),
        },
      }
    );
  }

  /** Renders the checkout process by adding necessary navigations */
  private RenderCheckout(): void {
    const me = this;
    me.getCustomerData = me._remoteOrderGroupPaymentService.hasCustomerInputFields;
    if (me.getCustomerData) {
      me.paymentNavigations.push(CUSTOMER_DATA_NAVIGATION);
    }
    me.paymentNavigations.push(CHECKOUT_NAVIGATION);
    me.PushChanges();
  }

  /** Checks if the shipping cart button is active based on service ID and AGB acceptance. */
  public isShippingCartBtnActive(): boolean {
    const me = this;
    let active = false;
    if (me.serviceId === WebShopMode.DeliveryGroup) {
      let minimumPriceRequirementIsMet = false;
      me.deliveryFeeInfo$.pipe(take(1)).subscribe((deliveryFeeInfo) => {
        if (deliveryFeeInfo) {
          minimumPriceRequirementIsMet = deliveryFeeInfo.minimumPriceRequirementIsMet;
        }
      }).unsubscribe();
      active = minimumPriceRequirementIsMet && me.hasAcceptedAGB;
    } else {
      active = me.hasAcceptedAGB;
    }
    return active;
  }

  // set tip value by changing slider value
  public onSliderValueChange() {
    const me = this;
    const newPercentage = me.tipSliderValue;
    me._remoteOrderGroupPaymentService.setTippingPercent(newPercentage);
    me._webShopService.setTrinkgeldPercentage(newPercentage)
  }

  // set tip value by changing input value
  public onInputTrinkgeldChange() {
    const me = this;
    const newAmount = +(me.tipInputValue.replace(",", "."));
    me._webShopService.setTrinkgeldAmount(newAmount)
    me._remoteOrderGroupPaymentService.setTippingAmount(newAmount);
  }

  public getFreeShippingText(remainingAmount: number): string {
    const me = this;
    const remaingAmountUntilFreeShipping = me._webShopService.formatCurrency(remainingAmount);
    return me._coreLanguageService.value("phWebshop_FreeShippingAt_BASE")
      .replace("{amount}", remaingAmountUntilFreeShipping);
  }

  /**  Sets the delivery group address with the given address.*/
  public setDeliveryGroupAddress(address: string) {
    const me = this;
    return me._coreLanguageService.value("phRemoteOrder_Group_Delivery_Address_To")
      .replace("{groupaddress}", `<span class="emphasized">${address}</span>`)
  }

  /** Sets the delivery end time with the given service time.*/
  public setDeliveryEndTime(selectedServiceTime: string) {
    const me = this;
    const day = me._displayDay(selectedServiceTime);
    const time = me._displayTime(selectedServiceTime);
    const isdayToday = me._isDayToday(selectedServiceTime);
    if (isdayToday) {
      return me._coreLanguageService.value("phRemoteOrder_Group_Delivery_Time_Today")
        .replace("{time}", `<span class="emphasized">${time}</span>`);
    } else {
      return me._coreLanguageService.value("phRemoteOrder_Group_Delivery_Time")
        .replace("{day}", `<span class="emphasized">${day}</span>`)
        .replace("{time}", `<span class="emphasized">${time}</span>`);
    }
  }

  /** Sets the delivery location name with the given name.*/
  public setDeliveryLocationName(name: string) {
    const me = this;
    return me._coreLanguageService.value("phRemoteOrder_Group_Delivery_From")
      .replace("{locationname}", `<span class="emphasized">${name}</span>`)
  }

  /** Sets the pickup end time with the given service time. */
  public setPickupEndTime(selectedServiceTime: string) {
    const me = this;
    const day = me._displayDay(selectedServiceTime);
    const time = me._displayTime(selectedServiceTime);
    const isdayToday = me._isDayToday(selectedServiceTime);
    if (isdayToday) {
      return me._coreLanguageService.value("phRemoteOrder_Group_Pickup_Time_Today")
        .replace("{time}", `<span class="emphasized">${time}</span>`);
    } else {
      return me._coreLanguageService.value("phRemoteOrder_Group_Pickup_Time")
        .replace("{day}", `<span class="emphasized">${day}</span>`)
        .replace("{time}", `<span class="emphasized">${time}</span>`);
    }
  }

  /**  Sets the group order end time with the given end time.*/
  public setGroupOrderEndTime(selectedEndTime: string) {
    const me = this;
    const day = me._displayDay(selectedEndTime);
    const time = me._displayTime(selectedEndTime);
    const isdayToday = me._isDayToday(selectedEndTime);
    if (isdayToday) {
      return me._coreLanguageService.value("phRemoteOrder_Group_End_Time_Today")
        .replace("{time}", `<span class="emphasized">${time}</span>`);
    } else {
      return me._coreLanguageService.value("phRemoteOrder_Group_End_Time")
        .replace("{day}", `<span class="emphasized">${day}</span>`)
        .replace("{time}", `<span class="emphasized">${time}</span>`);
    }
  }

  /** Displays the day for the given selected time. */
  private _displayDay(selectedTime: string) {
    const me = this;
    return me._remoteOrderGroupPaymentService.dayDisplayValue(selectedTime)
  }

  /** Displays the time for the given selected time.*/
  private _displayTime(selectedTime: string) {
    const me = this;
    return me._remoteOrderGroupPaymentService.timeDisplayValue(selectedTime)
  }

  /**  Checks if the given day is today */
  private _isDayToday(selectedDay: string) {
    const me = this;
    return me._remoteOrderGroupPaymentService.isDayToday(selectedDay)
  }


  /** Formats the given price as a currency string. */
  public formatCurrency(price: number): string {
    return this._webShopService.formatCurrency(price);
  }

  public loadDeliveryTotal(total: number, deliveryFee: number = 0) {
    const me = this;
    if (deliveryFee > 0) {
      return me.formatCurrency(total + deliveryFee)
    } else {
      return me.formatCurrency(total);
    }
  }

  /** Formats the tip slider label with the given value. */
  public formatTipSliderLabel(value: number | null) {
    const me = this;
    if (!value || value === 0) {
      return 0 + " %";
    }
    return value + " %";
  }

  /**
   * Checks if the provided content is not null or empty.
   * @param content - The string to check.
   * @returns True if the content is not null or empty, otherwise false.
   */
  public hasContent(content: string) {
    return !Utils.IsNullOrEmpty(content);
  }

  /** Load shake animation */
  public ShakeLabel(stateVar: string) {
    const me = this;
    me.states[stateVar] = !me.states[stateVar];
  }

  /**
 * Changes the active tab and updates the billing information visibility.
 * changes the active tab based on the provided index. 
 * 
 * @param -The index of the tab to be activated.
 */
  private _changeTab(index: number) {
    const me = this;
    if (me.getCustomerData && index <= 1 && me.matGroupSelectedIndex <= 1) {
      me.customerData.toggleBillingInfo(true);
    }
    me.matGroupSelectedIndex = index;
    me.activeLink = me.paymentNavigations[index];
    me.PushChanges();
  }

  /**
 * Initiates the checkout process.
 * 
 * @param - Whether to use the delivery address.
 * @returns - Resolves when checkout is complete.
 */
  private async openCheckout(useDeliveryAddress: boolean = false): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      await me._webShopService.onUserChange();
      const order = await me._webShopService.createAddPurchaseOrderDataModel(useDeliveryAddress);
      order.group_id = me.groupManageData.groupId;
      order.group_name = me.groupManageData.groupName;
      order.members = new Array<AddPurchaseOrderMemberDataModel>();

      const groupData = await me._remoteGroupOrderService.getGroupData();
      groupData.members.forEach(member => {
        order.members.push({
          member_id: member.userId,
          name: member.name,
          // server will set the account_id, the Class in backend allows nullable account_id,
          // so this will not lead to an error
          // account_id: 0 //! TODO account_id muss durch den Server gesetzt werden, nicht an die Clients herausgeben
        });
      });

      const successfullySetTotalPaidPrice = await me._remoteGroupOrderService.setTotalPaidPrice(order.grossprice);

      me._changeTab(me.getCustomerData ? 2 : 1);
      me.checkout.initialize(order, me._webShopService.userWebvoucher);
      me._overlaySpinnerService.HideLayoutSpinner();
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error("WebshopComponent.openCheckout", "catch", error);
      me._snackBarService.ShowErrorMessageFailed(129);
    }
  }

  /** Basket onContinue (async) */
  public async onContinue_basket() {
    const me = this;
    if (me.getCustomerData) {
      me._changeTab(1)
    } else {
      me.openCheckout(false)
    }
  }

  /** CustomerData onContinue (async) */
  public async onContinue_customerData(useDeliveryAddress: boolean = false) {
    const me = this;
    me.openCheckout(useDeliveryAddress);
  }

  public navigateBack() {
    const me = this;
    if (me.checkout && me.checkout.showWebDropIn) {
      me.checkout.toggleWebDropInVisibility(false); // If the WebDropIn is shown, hide it
    } else if (me.getCustomerData && me.activeLink === CUSTOMER_DATA_NAVIGATION && !me.customerData.showBillingInfo) {
      me.customerData.toggleBillingInfo(true);  // Close DeliveryAddress if open
    } else {
      me._navigateToPreviousTab();
    }
  }

  // handle navigation back in tabs and navigate to previous page when we are in first tab
  private _navigateToPreviousTab() {
    const me = this;
    if (me.matGroupSelectedIndex > 0) {
      me._changeTab(me.matGroupSelectedIndex - 1);
    } else {
      me._remoteGroupOrderService.setGroupPaymentStatus(Status.NotReady).then(() => {
        me._location.back();
      });

    }
  }

  /** navigation back by swiping from left to right,
   *  if smallview and tipslider is not sliding */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView && !me.tipSlider._isSliding) {
      me.navigateBack();
    }
  }
}
